import { IDrive } from '../DriveBase/types';

export interface IDriveVarSpeed extends IDrive {
    setSpeed: number;
    actSpeed: number;
}

export const schema = 'AutomationApps.Devices.Drives.DriveVarSpeed';
export const schemaFan = 'AutomationApps.Devices.Drives.FanVarSpeed';
export const schemaPump = 'AutomationApps.Devices.Drives.PumpVarSpeed';
export const schemaPump1 = 'AutomationApps.Devices.Drives.Pump1VarSpeed';
export const schemaPump2 = 'AutomationApps.Devices.Drives.Pump2VarSpeed';